import { useContext } from "react";
import { agencyContext } from "../providers/agency-provider";

export const useAgency = () => useContext(agencyContext);
